import WebpackerReact from 'webpacker-react';
import Index from '../components/settings/Recovery/Index';

WebpackerReact.setup({ AdminRecovery: Index });
